<app-header2></app-header2>
<!--====== PAGE TITLE PART START ======-->
<div class="page-title-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="page-title-item text-center">
                    <h2 class="title">Services</h2>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink='/'>Home </a></li>
                            <li class="breadcrumb-item active" aria-current="page">Services</li>
                        </ol>
                    </nav>
                </div> <!-- page title -->
            </div>
        </div> <!-- row -->
    </div> <!-- container -->
</div>
<!--====== PAGE TITLE PART ENDS ======-->
<!--====== SERVICES ITEM PART START ======-->
<div class="services-item-area pt-90 pb-120">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-8">
                <div class="single-services-item mt-30">
                    <img src="assets/images/services-thumb-1.jpg" alt="">
                    <div class="services-overlay">
                        <i class="fal fa-eye-dropper"></i>
                        <h4 class="title">UI/UX Design</h4>
                        <p>The functional goal of technical content is to help people use a product successfully. The business goal must tie the content.</p>
                    </div>
                </div> <!-- single services -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8">
                <div class="single-services-item mt-30">
                    <img src="assets/images/services-thumb-2.jpg" alt="">
                    <div class="services-overlay">
                        <i class="fal fa-gavel"></i>
                        <h4 class="title">IT Consultancy</h4>
                        <p>The functional goal of technical content is to help people use a product successfully. The business goal must tie the content.</p>
                    </div>
                </div> <!-- single services -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8">
                <div class="single-services-item mt-30">
                    <img src="assets/images/services-thumb-3.jpg" alt="">
                    <div class="services-overlay">
                        <i class="fal fa-map-marked-alt"></i>
                        <h4 class="title">Technology Prof.</h4>
                        <p>The functional goal of technical content is to help people use a product successfully. The business goal must tie the content.</p>
                    </div>
                </div> <!-- single services -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8">
                <div class="single-services-item mt-30">
                    <img src="assets/images/services-thumb-5.jpg" alt="">
                    <div class="services-overlay">
                        <i class="fal fa-hurricane"></i>
                        <h4 class="title">Web Development</h4>
                        <p>The functional goal of technical content is to help people use a product successfully. The business goal must tie the content.</p>
                    </div>
                </div> <!-- single services -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8">
                <div class="single-services-item mt-30">
                    <img src="assets/images/services-thumb-4.jpg" alt="">
                    <div class="services-overlay">
                        <i class="fal fa-bezier-curve"></i>
                        <h4 class="title">App Development</h4>
                        <p>The functional goal of technical content is to help people use a product successfully. The business goal must tie the content.</p>
                    </div>
                </div> <!-- single services -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8">
                <div class="single-services-item mt-30">
                    <img src="assets/images/services-thumb-6.jpg" alt="">
                    <div class="services-overlay">
                        <i class="fal fa-umbrella"></i>
                        <h4 class="title">Game Design</h4>
                        <p>The functional goal of technical content is to help people use a product successfully. The business goal must tie the content.</p>
                    </div>
                </div> <!-- single services -->
            </div>
        </div> <!-- row -->
    </div> <!-- container -->
</div>
<!--====== SERVICES ITEM PART ENDS ======-->
<!--====== SERVICES PLANS PART START ======-->
<div class="services-plans-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="services-title mb-50">
                    <span>plans</span>
                    <h2 class="title">Here is plans</h2>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="plans-tab-btn d-flex justify-content-md-end justify-content-start">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Monthly</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Yearly</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Early Birds</b>
                            <h3 class="title">$ <span>9</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Team</b>
                            <h3 class="title">$ <span>32</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Personal</b>
                            <h3 class="title">$ <span>69</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Plutinum</b>
                            <h3 class="title">$ <span>99</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Early Birds</b>
                            <h3 class="title">$ <span>56</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Team</b>
                            <h3 class="title">$ <span>99</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Personal</b>
                            <h3 class="title">$ <span>133</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-8 mt-30">
                        <div class="plans-item bg_cover text-center" style="background-image: url(assets/images/plans-thumb.jpg);">
                            <b>Plutinum</b>
                            <h3 class="title">$ <span>599</span></h3>
                            <span>Per Month</span>
                            <p>The functional goal of technical content is to help people use a product successfully.</p>
                            <a class="main-btn main-btn-2" href="#">Purchase Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== SERVICES PLANS PART ENDS ======-->
<!--====== NEWS PART START ======-->
<div class="news-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-9">
                <div class="section-title-2 text-center pl-25 pr-25">
                    <h2 class="title">News Feeds</h2>
                    <p>Does any industry face a more complex audience journey and marketing sales process than B2B technology.</p>
                </div> <!-- section title 2 -->
            </div>
        </div> <!-- row -->
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-9">
                <div class="single-news mt-30">
                    <img src="assets/images/news-1.jpg" alt="">
                    <div class="single-news-overlay">
                        <span>Design/SEO</span>
                        <h5 class="title"><a routerLink="/blog-detail">A series of iOS 7 inspired vector icons.</a></h5>
                        <a routerLink="/blog-detail"><i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div> <!-- single news -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9">
                <div class="single-news mt-30">
                    <img src="assets/images/news-2.jpg" alt="">
                    <div class="single-news-overlay">
                        <span>Design/SEO</span>
                        <h5 class="title"><a routerLink="/blog-detail">A series of iOS 7 inspired vector icons.</a></h5>
                        <a routerLink="/blog-detail"><i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div> <!-- single news -->
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9">
                <div class="single-news mt-30">
                    <img src="assets/images/news-3.jpg" alt="">
                    <div class="single-news-overlay">
                        <span>Design/SEO</span>
                        <h5 class="title"><a routerLink="/blog-detail">A series of iOS 7 inspired vector icons.</a></h5>
                        <a routerLink="/blog-detail"><i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div> <!-- single news -->
            </div>
        </div> <!-- row -->
    </div> <!-- container -->
</div>
<!--====== NEWS PART ENDS ======-->
<app-footer2></app-footer2>
